<template>
    <div>
        <ul class="list-group">
            <a href="#"
               v-for="ex of exchanges"
               class="list-group-item f -gutter-small"
               @click.prevent="openExchange(ex)">
                <div class="icon">
                    <i class="glyphicon glyphicon-home" v-if="ex.mean === 'address'"></i>
                    <i class="glyphicon glyphicon-envelope" v-if="ex.mean === 'email'"></i>
                    <i class="glyphicon glyphicon-earphone" v-if="ex.mean === 'phone'"></i>
                    <i class="glyphicon glyphicon-user" v-if="ex.mean === null"></i>
                </div>
                <div class="expand content">
                    <div>
                        <span v-for="contact of ex.contacts">
                            <span v-if="$index">+</span>
                            {{ contact.title | shortTitle }}
                            {{ contact.first_name }}
                            {{ contact.last_name }}
                        </span>
                        |
                        <span class="less-important">{{ ex.staff.name }}</span>
                    </div>
                    <div class="date">
                        {{ ex.date | timeFromNow | ucfirst }}
                        <span>({{ ex.date | date 'LL' }})</span>
                    </div>
                    <div class="summary">
                        {{ ex.summary }}

                        <span v-if="ex.fee"
                              class="fee">
                            ({{{ ex.fee | money }}})
                        </span>
                    </div>
                </div>
            </a>
        </ul>


        <loader v-show="loading" class="bigger-loader"></loader>

        <div class="load-more">
            <a href="#"
               v-if="hasNext && !loading"
               v-on:click.prevent="updateList(true)"
               class="btn btn-default">
                Charger plus
            </a>
        </div>

        <modal :show.sync="showModal"
               v-if="showModal">
            <div class="modal-header" slot="modal-header">
                <h3>{{ showExchange.summary }}</h3>
            </div>

            <div class="modal-body" slot="modal-body">
                <h4>Contacts</h4>

                <div>
                    <em>{{ showExchange.staff.name }}</em>
                </div>

                <div v-for="contact in showExchange.contacts">
                    {{ contact.title | shortTitle }}
                    {{ contact.first_name }}
                    {{ contact.last_name }}
                </div>

                <div v-if="showExchange.description">
                    <h4>Description</h4>
                    {{{ showExchange.description | nl2br }}}
                </div>

                <div v-if="showExchange.fee">
                    <h4>Honoraires</h4>
                    <p>
                        {{{ showExchange.fee | money }}}
                    </p>
                </div>

                <div v-if="showExchange.documents.length">
                    <h4>Documents</h4>

                    <ul>
                        <li v-for="doc in showExchange.documents">
                            <a :href="doc.file.content"
                               target="_blank">
                                {{ doc.file.content | filename }}
                            </a>
                        </li>
                    </ul>
                </div>
            </div>

            <div class="modal-footer" slot="modal-footer">
                <button class="btn btn-link"
                        @click.prevent="showModal = false">
                    Fermer
                </button>
            </div>
        </modal>
    </div>
</template>

<style type="text/css"
       scoped>
    .fee {
        color: grey;
    }
</style>

<script type="text/ecmascript-6">
    import {makeUpdateList} from '../../utils';
    import {list as listExchanges} from '../../api/exchanges';
    import Loader from '../../components/Loader';
    import Modal from 'vue-strap/src/Modal';

    export default {
        components: {
            Loader,
            Modal
        },
        props: {
            client: {
                'default': () => ({})
            },
            contract: {
                'default': () => ({})
            }
        },
        data() {
            return {
                exchanges: [],
                loading: false,
                page: 1,
                hasNext: false,
                showModal: false,
                showExchange: {}
            };
        },
        computed: {
            fetchArgs() {
                if (this.client.id) {
                    return {
                        client: this.client.id
                    };
                }

                if (this.contract.id) {
                    return {
                        contract: this.contract.id
                    };
                }

                return {};
            }
        },
        methods: {
            updateList: makeUpdateList({
                loading: 'loading',
                page: 'page',
                hasNext: 'hasNext',
                list: 'exchanges',
                fetch: async function (page) {
                    return await listExchanges(Object.assign({page}, this.fetchArgs));
                }
            }),
            openExchange(exchange) {
                this.showExchange = exchange;
                this.showModal = true;
            }
        },
        ready() {
            this.updateList();
        }
    };
</script>



// WEBPACK FOOTER //
// ExchangesTab.vue?41a4efb6